module.exports = __webpack_public_path__ + "static/img/ali-icon.b76bb4c9.png";